var _g, _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "20 0 110 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.2231 23.1337C29.471 20.8202 30.6824 18.3168 32.9287 17.542L50.0569 11.6354C54.0656 10.253 58.4592 10.5185 62.2723 12.3735L69.233 15.7597C73.1403 17.6605 76.1064 21.0687 77.4498 25.2009L85.93 51.2863C86.6828 53.6001 85.4718 56.1036 83.2244 56.8784L49.4988 68.5088C47.2514 69.2836 44.8221 68.036 44.0693 65.7226L30.2231 23.1337Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.0715 15.6575C33.3177 13.3437 34.5297 10.8402 36.7771 10.0658L60.164 2L79.1942 11.2577L89.7766 43.8101C90.5294 46.1239 89.3184 48.6274 87.071 49.4018L53.3454 61.0326C51.1016 61.807 48.6687 60.5594 47.916 58.2464L34.0715 15.6575Z",
    fill: "#E9E9E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7089 10.1632L60.0542 2L79.2081 11.3108L70.6803 14.2496C67.3819 15.386 63.8144 13.5563 62.7089 10.1632Z",
    fill: "#D4D4D4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9136 23.9239L62.3618 18.2632L63.8128 22.7124L47.3646 28.3731L45.9136 23.9239Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.668 32.3783L56.0248 29.8457L57.4758 34.2945L50.1153 36.8271L48.668 32.3783Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4209 40.8308L63.1089 36.8086L64.4835 41.035L52.7992 45.0572L51.4209 40.8308Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0.76123,
    width: 116.153,
    height: 117.977,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/File.7f88c4946d5f2dfc8fc4750970644cba.svg";
export { ForwardRef as ReactComponent };